import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { MenuItem, type MenuItemProps } from '@mui/material';

const UploadMenuItem = styled(MenuItem)<MenuItemProps>(
  ({ onClick, disabled }) => {
    if (typeof onClick === 'undefined' || disabled) {
      return {
        backgroundColor: 'transparent !important',
        cursor: 'initial',
      };
    }
  },
  {
    height: 36,
  },
  addHighContrastStyles({
    opacity: '1 !important',
  }),
);

export default UploadMenuItem;
